import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

export interface VisibilityOnIconProps {}

export const VisibilityOnIcon = (
  _props: VisibilityOnIconProps,
): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 20 14">
      <path
        d="M11.791,7a11.024,11.024,0,0,0-10,7,11.024,11.024,0,0,0,10,7,11.024,11.024,0,0,0,10-7A11.024,11.024,0,0,0,11.791,7Zm0,11.455A4.375,4.375,0,0,1,7.416,14a4.376,4.376,0,1,1,8.75,0A4.375,4.375,0,0,1,11.791,18.455Zm0-7A2.419,2.419,0,0,0,9.291,14a2.419,2.419,0,0,0,2.5,2.545c1.477,0,3.125-1.06,3.125-2.545S13.268,11.455,11.791,11.455Z"
        transform="translate(-1.791 -7)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
